import { ReactNode } from 'react';
import { Spinner } from "@heroui/react";
import { blockStyles, componentClasses } from '../utils/blockStyles.utils';

interface LoadingStateProps {
  message?: string;
}

/**
 * Consistent loading state for dashboard blocks
 */
export const BlockLoadingState = ({ message = "Gegevens aan het ophalen..." }: LoadingStateProps) => {
  return (
    <div className={componentClasses.loadingState}>
      <Spinner size="lg" color="primary" className={blockStyles.loading.spinner} />
      <p className={blockStyles.loading.text}>{message}</p>
    </div>
  );
};

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

/**
 * Consistent empty state for dashboard blocks
 */
export const BlockEmptyState = ({ icon, title, description, action }: EmptyStateProps) => {
  return (
    <div className={componentClasses.emptyState}>
      {icon && <div className={blockStyles.empty.icon}>{icon}</div>}
      <h3 className={blockStyles.empty.title}>{title}</h3>
      {description && <p className={blockStyles.empty.description}>{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};

